import { Translation } from 'hooks/useTranslation/useTranslation';
import { FilterChip } from 'v2/components/SearchAndFilters/SearchAndFilters';

import { FilterAccess, FilterOfficeMode, UserGroupFilterState } from './userGroupFilterTypes';

interface Params {
  translation: Translation;
  filters: UserGroupFilterState;
}

export const createUserGroupFilterChips = ({ filters, translation }: Params): FilterChip[] => {
  const accessLabels: Record<keyof FilterAccess, string> = {
    noUsers: translation.no_users,
    noSchedule: translation.no_schedule,
    noDevices: translation.no_devices
  };

  const { filterAccess, filterOfficeMode } = filters.filter;
  const { setFilterAccess, setFilterOfficeMode } = filters.setters;

  return [
    ...(Object.keys(filterAccess) as (keyof FilterAccess)[])
      .filter((key) => filterAccess[key])
      .map((key) => ({
        label: accessLabels[key],
        onDelete: () => setFilterAccess((current) => ({ ...current, [key]: false }))
      })),
    ...(filterOfficeMode !== null
      ? [
          {
            label: filterOfficeMode === FilterOfficeMode.Allowed ? translation.allowed : translation.not_allowed,
            onDelete: () => setFilterOfficeMode(null)
          }
        ]
      : [])
  ];
};
